import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { useAuth } from "../contexts/AuthContext";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";
import PreAdmissionMobile from "./PreAdmissionMobile";
import FormsMobile from "./ClientsCategory/FormsMobile";
import ClinicalInformationsMobile from "./ClientsCategory/ClinicalInformationsMobile";
import UploadMobile from "./ClientsCategory/UploadMobile";
import SwotsMobile from "./ClientsCategory/SwotsMobile";
import ClientNotesMobile from "./ClientsCategory/ClientNotesMobile";
import GeneralInformationMobile from "./ClientsCategory/GeneralInformationMobile";
import AlertMobile2 from "./ClientsCategory/AlertMobile2";
import { showCustomToast } from "./Misc/CustomToast";
import AdminMobile from "./ClientsCategory/AdminMobile";

function ClientProfilTabMobile(props) {
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  const [value, setValue] = useState("1");
  const [userRole, setUserRole] = useState("");
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const handleModificationChange = (isModified) => {
    setHasUnsavedChanges(isModified);
  };
  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const handleChange = (event, newValue) => {
    if (["1", "2", "4"].includes(value) && hasUnsavedChanges) {
      showCustomToast("Don't forget to save your modification!", "error");
    } else {
      setValue(newValue);
    }
  };

  return (
    <div className="tab-client-container">
      <Box>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divier",
              width: "auto",
            }}
          >
            <Tabs
              variant="scrollable"
              allowScrollButtonsMobile
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Pre-admission" value="1" />

              <Tab label="General information" value="2" />

              {userRole !== "Admission staff" &&
              userRole !== "Hospitality Staff" ? (
                <Tab label="Admission forms" value="3" />
              ) : (
                ""
              )}

              {userRole !== "Admission staff" &&
              userRole !== "Hospitality Staff" ? (
                <Tab label="Clinical documents" value="4" />
              ) : (
                ""
              )}

              {userRole !== "Admission staff" ? (
                <Tab label="Notes" value="5" />
              ) : (
                ""
              )}

              {userRole !== "Admission staff" ? (
                <Tab label="Discharge & Ongoing care" value="6" />
              ) : (
                ""
              )}

              <Tab label="Upload" value="7" />

              <Tab label="Alerts" value="8" />
              {(userRole === "Super Admin" ||
                userRole === "Admin" ||
                userRole === "Clinical Director") && (
                <Tab label="Admin" value="9" />
              )}
            </Tabs>
          </Box>

          {(() => {
            switch (value) {
              case "1":
                return (
                  <TabPanel
                    value="1"
                    // sx={{ width: "100vw", marginLeft: 0 }}
                  >
                    <PreAdmissionMobile
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "2":
                return (
                  <TabPanel value="2" style={{ marginLeft: 0 }}>
                    <GeneralInformationMobile
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "3":
                return (
                  <TabPanel value="3">
                    <FormsMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "4":
                return (
                  <TabPanel value="4">
                    <ClinicalInformationsMobile
                      onModificationChange={handleModificationChange}
                      clientId={props.clientId}
                      {...props}
                    />
                  </TabPanel>
                );
              case "5":
                return (
                  <TabPanel value="5">
                    <ClientNotesMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "6":
                return (
                  <TabPanel value="6">
                    <SwotsMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "7":
                return (
                  <TabPanel value="7">
                    <UploadMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );

              case "8":
                return (
                  <TabPanel value="8">
                    <AlertMobile2 clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              case "9":
                return (
                  <TabPanel value="9">
                    <AdminMobile clientId={props.clientId} {...props} />
                  </TabPanel>
                );
              default:
                return null;
            }
          })()}
        </TabContext>
      </Box>
    </div>
  );
}

export default ClientProfilTabMobile;
